import React, {useState, useEffect} from 'react';
import {Column} from '@ant-design/plots';
import {DatePicker, Select} from "antd";
import dayjs from "dayjs";
import {API_PATH} from "../../components/const";
import axios from "axios";
import {toast} from "react-toastify";
import { each, groupBy } from '@antv/util';

const GenderComparasion = () => {
    const [time, setTime] = useState(new Date());
    const [month, setMonth] = useState(time.getMonth());
    const [year, setYear] = useState(time.getFullYear());
    const [data, setData] = useState([]);
    const dateFormat = 'YYYY-MM';
    const [offices, setOffices] = useState([])
    const [rooms, setRooms] = useState([])
    const [cameras, setCameras] = useState([])
    const [selectOffices, setSelectOffices] = useState(null)
    const [selectDate, setSelectDate] = useState("")
    const [selectCameras, setSelectCameras] = useState(null)
    const [sendData, setSendData] = useState({
        building_id: null,
    })
    const getBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') +  "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res?.data)
                setSendData({...sendData, building_id: res?.data?.items[0]?.id})
                getCameras(res?.data?.items[0]?.id)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }

    const getCameras = (id) => {


        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/smartcamera/all?building_id=" + id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setCameras(res?.data?.items)
                setSelectCameras( res?.data?.items[0]?.id)


                // if (sendData?.building_id === null && selectCameras === null ){
                        fetch(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/gender/analitcs/compare/" + id + "/" + (selectCameras ? selectCameras : res?.data?.items[0]?.id) + "/" +( selectDate === "" ? time.getFullYear() : selectDate?.slice(0, 4)) + "/" +   (selectDate === "" ?  Number(time.getMonth() + 1)  : selectDate?.slice(5, 7)) , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                            .then((response) => response.json())
                            .then((json) => {
                                    setData([
                                        ...json.building_records?.map(item =>{
                                            return {
                                                ...item,
                                                type: item?.type === "male" ? "Мужской" : "Женский",
                                                name: "В филиале",
                                            }
                                        }),
                                        ...json.camera_records?.map(item => {
                                            return {
                                                ...item,
                                                type: item?.type === "male" ? "Мужской" : "Женский",
                                                name: "В камере",
                                                // type: "camera_records",
                                            }
                                        })
                                    ])
                                }
                            )
                    // }
            })
            .catch(err => {
                toast.error("Ошибка")
            }   )
    }
    const getCamerasSearch = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/smartcamera/all?building_id=" + sendData?.building_id + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setCameras(res?.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    function onChange(date, dateString) {
        setSelectDate(dateString)
        if (dateString?.length > 0) {
            // fetch(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/gender/" + dateString.slice(0, 4) + "/" + Number(dateString.slice(5, 7)), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            fetch(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/gender/analitcs/compare/" + sendData?.building_id + "/" + selectCameras + "/" +  dateString.slice(0, 4) + "/" + dateString.slice(5, 7), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((response) => response.json())
                .then((json) => {
                    setData([
                        ...json.building_records?.map(item =>{
                            return {
                                ...item,
                                type: item?.type === "male" ? "Мужской" : "Женский",
                                name: "В филиале",
                            }
                        }),
                        ...json.camera_records?.map(item => {
                            return {
                                ...item,
                                type: item?.type === "male" ? "Мужской" : "Женский",
                                name: "В камере",
                                // type: "camera_records",
                            }
                        })
                    ])
                      }
                )
        } else (
            console.log('fetch data failed')
        )
    }


    const getDataCameraFilter = (e) => {
                fetch(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/gender/analitcs/compare/" + sendData?.building_id + "/" +e + "/" + selectDate?.slice(0, 4) + "/" +  selectDate?.slice(5, 7) , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                    .then((response) => response.json())
                    .then((json) => {
                        setData([
                            ...json.building_records?.map(item =>{
                                return {
                                    ...item,
                                    type: item?.type === "male" ? "Мужской" : "Женский",
                                    name: "В филиале",
                                }
                            }),
                            ...json.camera_records?.map(item => {
                                return {
                                    ...item,
                                    type: item?.type === "male" ? "Мужской" : "Женский",
                                    name: "В камере",
                                    // type: "camera_records",
                                }
                            })
                        ])
                        }
                    )
    }
    // https://api.cradle-vision.com/company/1/analitics/gender/analitcs/compare/1/1/1/1
    const annotations = [];
    each(groupBy(data, 'date'), (values, k) => {
        const value = values.reduce((a, b) => a + b.value, 0);
        annotations.push({
            type: 'text',
            position: [k, value],
            content: `${value}`,
            style: {
                textAlign: 'center',
                fontSize: 10,
                fill: 'rgba(0,0,0,0.85)',
            },
            offsetY: 0,
        });
    });
    const config = {
        data,
        xField: 'date',
        yField: 'value',
        isGroup: true,
        isStack: true,
        groupField: 'name',
        seriesField: 'type',
        color:[ '#5664D2', '#FC53F5',  '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C'],

        label: {
            style: {
                fill: 'white',
                fontSize: 8,
            },
            position: 'middle',
            layout: [
                {
                    type: 'interval-adjust-position',
                },
                {
                    type: 'interval-hide-overlap',
                },
                {
                    type: 'adjust-color',
                },
            ],
        },
        // annotations,

    };
    useEffect(() => {
        getBuilding();
        setSelectDate(time.getFullYear() + "-" + Number(time.getMonth() + 1))
    }, []);

    return (
        <div>
            <div className="visitor visitor-box gender-comp">
                <div className="chart-box">

                    <div className="d-flex justify-content-between">
                        <div className="visitor-title">
                            <h1><span className="font-family-medium">
                    Сравнение по камерам
                                {/*<button onClick={() => console.log(data)}>TEST</button>*/}
                </span>
                            </h1>
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center">
                                <div className="inputs-box mb-0 mr-16" style={{width: "200px"}}>
                                    <Select
                                        showSearch
                                        placeholder="Поиск, чтобы выбрать"
                                        optionFilterProp="children"
                                        className="w-100"
                                        value={sendData?.building_id}
                                        onSearch={getBuilding}
                                        onChange={(e) => {
                                            setSendData({...sendData, building_id: e})
                                            setData([])
                                            setSelectCameras(null)
                                            getCameras(e)
                                        }}
                                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                        filterSort={(optionA, optionB) =>
                                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                        }
                                        options={offices?.map((item) => {
                                            return {
                                                value: item.building_id,
                                                label:
                                                item?.branch_title
                                            };
                                        })}
                                    />
                                </div>
                            </div>
                            <div className="inputs-box mb-0 mr-16" style={{width: "200px"}}>
                                <Select
                                    showSearch
                                    placeholder="Поиск, чтобы выбрать"
                                    optionFilterProp="children"
                                    className="w-100"
                                    onSearch={getCamerasSearch}
                                    value={selectCameras}
                                    onChange={(e) => {
                                        setSelectCameras( e )
                                        getDataCameraFilter(e)
                                    }}
                                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    options={cameras?.map((item) => {
                                        return {
                                            value: item.id,
                                            label:
                                            item?.name
                                        };
                                    })}
                                />
                            </div>
                            <div>
                                <DatePicker picker="month"
                                            defaultValue={dayjs(year + "-"  + (month < 9  ? "0" : "") +  Number(month + 1), dateFormat)}
                                            onChange={onChange}
                                            format={dateFormat}
                                />
                            </div>
                        </div>

                    </div>
                    <Column {...config} />

                </div>
            </div>
        </div>
    )
};
export default GenderComparasion